import React from "react";
import DynamicFieldConfigType from "../types/DynamicFieldConfigType";
import FormTextAreaField from "../../fields/textAreaField";
import { useDynamicFormRenderer } from "../context/dynamicFormRendererContext";
import FieldIdentifier from "../enums/FieldIdentifier";
import EnhancementFieldType from "shared/enums/EnhancementFieldType";

/**
 * @name FormTextAreaFieldWrapper
 * @interface DynamicFieldConfigType
 * @param props
 * @constructor
 */
export default function FormTextAreaFieldWrapper(props: DynamicFieldConfigType) {
  const { isAITextEnhancementEnabled, registrationId } = useDynamicFormRenderer();

  const enhancementFieldType = React.useMemo(() => {
    switch (props.schemaObj.identifier) {
      case FieldIdentifier.ORGANIZATION_DESCRIPTION:
        return EnhancementFieldType.ORGANIZATION_DESCRIPTION;
      case FieldIdentifier.TABLETALK_BIOGRAPHY:
        return EnhancementFieldType.TABLE_TALK_BIO;
      default:
        return undefined;
    }
  }, [props.schemaObj.identifier]);

  return (
    <React.Fragment>
      <FormTextAreaField
        name={props.schemaObj.id}
        required={props.schemaObj.mandatory}
        label={props.schemaObj.label}
        additionalLabel={props.schemaObj.secondaryLabel ? (props.schemaObj.secondaryLabel as string) : undefined}
        iconUrl={props.schemaObj.imageIcon?.url}
        infoLabel={props.schemaObj.infoLabel ? (props.schemaObj.infoLabel as string) : undefined}
        disabled={props.schemaObj.disabled}
        validate={props.validationFn}
        minLength={props.schemaObj.minimum}
        isAITextAssistEnabled={isAITextEnhancementEnabled && props.schemaObj.aiTextEnhancementEnabled}
        enhancementFieldType={enhancementFieldType}
        registrationId={registrationId}
        maxCount={props.schemaObj.maximum}
        placeholder={props.schemaObj.placeholderLabel}
        conflictValue={props.schemaObj.conflictValue}
        className={props.schemaObj.className}
        fullWidth={true}
        indented={props.schemaObj.indented}
        withCount
      />
    </React.Fragment>
  );
}
